<template>
  <v-app id="v-app">
    <v-card>
      <v-card-title>
        <h1>
          Sammelpickliste
        </h1>
        <v-spacer/>
      </v-card-title>
      <v-container>
        <v-dialog
            ref="scheduledDateDialog"
            v-model="dateModal"
            :return-value.sync="dateFilter"
            persistent
            width="290px"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-text-field
                v-model="dateFilter"
                label="Datum auswählen"
                prepend-icon="mdi-calendar"
                readonly
                v-bind="attrs"
                v-on="on"
            ></v-text-field>
          </template>
          <v-date-picker
              v-model="dateFilter"
              scrollable
              locale="de-de"
          >
            <v-spacer></v-spacer>
            <v-btn text color="primary"
                   @click="dateFilter = '';
                         dateModal = false;
                         ">
              Clear
            </v-btn>
            <v-btn
                text
                color="primary"
                @click="dateModal = false"
            >
              Abbrechen
            </v-btn>
            <v-btn
                text
                color="primary"
                @click="$refs.scheduledDateDialog.save(dateFilter);
                      dateModal = false;
                      "
            >
              OK
            </v-btn>
          </v-date-picker>
        </v-dialog>
      </v-container>
      <v-btn class="ma-5" color="primary" @click="createList(dateFilter)">Liste downloaden</v-btn>
    </v-card>
  </v-app>
</template>
<style>

</style>
<script class="ts">
import 'vuetify/dist/vuetify.min.css';
import axios from "axios";

export default {
  name: "SchwammPicklistCollective",
  data: function () {
    return {
      dateModal: false,
      dateFilter: ''
    }
  },
  props: {},
  methods: {
    createList(date) {
      return axios.post('/api/v2/schwamm/picklist/printCollective', {date: date}, {responseType: "blob"}).then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data], {type: 'application/pdf'}));
        const fileLink = document.createElement('a');
        fileLink.href = url;
        fileLink.setAttribute('download', 'picklist.pdf');
        document.body.appendChild(fileLink);
        fileLink.click();
      })
    }
  }
}
</script>